/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";
import { useSelector, RootStateOrAny } from "react-redux";

const LISTAR_PLANTAO_VENDAS = `locais/common/plantao-vendas/listar/v1`;

const fetchData = async () => {
  const response = await instance.get(LISTAR_PLANTAO_VENDAS);
  return response?.data?.data;
};

export function useListarPlantaoVendas() {
  const { signed } = useSelector<RootStateOrAny, any>((state) => state.user);

  const query = useQuery({
    queryFn: fetchData,
    queryKey: ["use_listar_plantao_vendas"],
    refetchOnWindowFocus: false,
    enabled: signed,
  });
  return query;
}
